import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from '../services/api';

const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const fmtData = d => { if (!d) return '—'; const p = String(d).split('T')[0].split('-'); return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : '—'; };
const toISO = d => d ? d.toISOString().split('T')[0] : '';
const hoje = toISO(new Date());
const inicioMes = toISO(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
const fimMes = toISO(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));

const card = { background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '18px 20px' };
const th = { padding: '0 10px 8px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '10px 10px 10px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };
const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const ABAS = ['Dashboard', 'A Pagar', 'A Receber', 'Lançamentos', 'Bancos', 'Importar OFX'];

export default function Financeiro() {
  const [aba, setAba] = useState('Dashboard');
  const [dashboard, setDashboard] = useState(null);
  const [lancamentos, setLancamentos] = useState([]);
  const [contas, setContas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [modalLanc, setModalLanc] = useState(false);
  const [modalPagar, setModalPagar] = useState(null);
  const [modalConta, setModalConta] = useState(false);
  const [form, setForm] = useState({});
  const [formConta, setFormConta] = useState({});
  const [filtro, setFiltro] = useState({ inicio: inicioMes, fim: fimMes, status: '', conta_id: '', tipo: '' });
  const [busca, setBusca] = useState('');
  const [selecionados, setSelecionados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ofxTransacoes, setOfxTransacoes] = useState([]);
  const [ofxContaId, setOfxContaId] = useState('');
  const [ofxLoading, setOfxLoading] = useState(false);
  const [vendas, setVendas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [buscaCliente, setBuscaCliente] = useState({});
  const [modoLinha, setModoLinha] = useState({}); // {idx: 'manual'|'venda'|null}
  const [dadosLinha, setDadosLinha] = useState({}); // {idx: {categoria_id, fornecedor_id, descricao, venda_id}}
  const [novaCategoria, setNovaCategoria] = useState({ show: false, nome: '', tipo: 'despesa', cor: '#6B7A8D' });
  const [novoFornecedor, setNovoFornecedor] = useState({ show: false, nome: '', cpf_cnpj: '' });
  const [modalDividir, setModalDividir] = useState(null);
  const [modalParcial, setModalParcial] = useState(null);
  const [valorParcial, setValorParcial] = useState('');
  const [modalExtrato, setModalExtrato] = useState(null);
  const [extrato, setExtrato] = useState(null);
  const [filtroExtrato, setFiltroExtrato] = useState({ inicio: inicioMes, fim: fimMes });
  const [modalTransf, setModalTransf] = useState(false);
  const [formTransf, setFormTransf] = useState({ conta_origem: '', conta_destino: '', valor: '', data: '', descricao: 'Transferência entre contas' }); // lançamento a dividir
  const [divisoes, setDivisoes] = useState([{ forma: '', valor: '', conta_id: '' }]);
  const ofxRef = useRef();

  const carregarExtrato = async (conta, f) => {
    try {
      const ff = f || filtroExtrato;
      const r = await api.get("/financeiro/contas/" + conta.id + "/extrato", { params: ff });
      setExtrato(r.data);
    } catch(e) { console.error(e); }
  };

  const abrirExtrato = async (conta) => {
    setModalExtrato(conta);
    const ff = filtroExtrato;
    const r = await api.get("/financeiro/contas/" + conta.id + "/extrato", { params: ff });
    setExtrato(r.data);
  };
  const setV = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const carregarDashboard = useCallback(() => api.get('/financeiro/dashboard').then(r => setDashboard(r.data)).catch(console.error), []);
  const carregarContas = useCallback(() => api.get('/financeiro/contas').then(r => setContas(r.data)).catch(console.error), []);
  const carregarCategorias = useCallback(() => api.get('/financeiro/categorias').then(r => setCategorias(r.data)).catch(console.error), []);

  const carregarLancamentos = useCallback((f) => {
    const ff = f || filtro;
    const params = {};
    if (ff.inicio) params.inicio = ff.inicio;
    if (ff.fim) params.fim = ff.fim;
    if (ff.status) params.status = ff.status;
    if (ff.conta_id) params.conta_id = ff.conta_id;
    if (ff.tipo) params.tipo = ff.tipo;
    api.get('/financeiro/lancamentos', { params }).then(r => setLancamentos(r.data)).catch(console.error);
  }, []); // eslint-disable-line

  useEffect(() => {
    carregarDashboard();
    carregarContas();
    carregarCategorias();
    carregarLancamentos();
    api.get('/fornecedores').then(r => setFornecedores(r.data)).catch(console.error);
    api.get('/vendas').then(r => setVendas(r.data)).catch(console.error);
    api.get('/clientes').then(r => setClientes(r.data)).catch(console.error);
  }, []); // eslint-disable-line

  useEffect(() => {
    setBusca('');
    setSelecionados([]);
    if (aba === 'A Pagar') carregarLancamentos({ ...filtro, tipo: 'despesa' });
    else if (aba === 'A Receber') carregarLancamentos({ ...filtro, tipo: 'receita' });
    else if (aba === 'Lançamentos') carregarLancamentos(filtro);
  }, [aba]); // eslint-disable-line

  const salvarLancamento = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dadosEnvio = { ...form };
      if (form.modo_lancamento === 'fixo') {
        dadosEnvio.valor = (parseFloat(form.valor_parcela || 0) * parseInt(form.total_parcelas || 1)).toFixed(2);
      }
      if (form.id) await api.put('/financeiro/lancamentos/' + form.id, dadosEnvio);
      else await api.post('/financeiro/lancamentos', dadosEnvio);
      setModalLanc(false); setForm({});
      carregarLancamentos(); carregarDashboard();
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
    finally { setLoading(false); }
  };

  const pagarLancamento = async () => {
    try {
      const valorPago = parseFloat(form.valor_pago || modalPagar.valor);
      const saldoAberto = parseFloat(modalPagar.venda_saldo_aberto || 0);
      const isParcial = modalPagar.venda_id && saldoAberto > 0 && valorPago < parseFloat(modalPagar.valor);
      
      if (modalPagar.venda_id && saldoAberto > 0) {
        // Pagamento parcial de venda - usar rota de recebimento
        await api.post('/vendas/' + modalPagar.venda_id + '/recebimento', {
          valor: valorPago,
          data_pagamento: form.data_pagamento || hoje,
          conta_id: form.conta_id_pag || modalPagar.conta_id
        });
        // Se pagou tudo, marcar lancamento como pago
        if (valorPago >= saldoAberto) {
          await api.put('/financeiro/lancamentos/' + modalPagar.id + '/pagar', { data_pagamento: form.data_pagamento || hoje, conta_id: form.conta_id_pag || modalPagar.conta_id });
        }
      } else {
        await api.put('/financeiro/lancamentos/' + modalPagar.id + '/pagar', { data_pagamento: form.data_pagamento || hoje, conta_id: form.conta_id_pag || modalPagar.conta_id });
      }
      setModalPagar(null); setForm({});
      carregarLancamentos(); carregarDashboard();
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
  };

  const cancelarUm = async (id) => {
    if (!window.confirm('Cancelar este lançamento?')) return;
    await api.delete('/financeiro/lancamentos/' + id);
    const novoFiltro = { ...filtro, status: 'pendente' };
    setFiltro(novoFiltro);
    carregarLancamentos(novoFiltro);
    carregarDashboard();
  };

  const cancelarLote = async () => {
    if (!selecionados.length) { alert('Nenhum selecionado'); return; }
    if (!window.confirm(`Cancelar ${selecionados.length} lançamento(s)?`)) return;
    try {
      await api.post('/financeiro/lancamentos/cancelar-lote', { ids: selecionados });
      setSelecionados([]);
      setBusca('');
      // Recarregar sem filtro de data para mostrar todos os cancelados
      const novoFiltro = { ...filtro, inicio: inicioMes, fim: fimMes, status: '' };
      setFiltro(novoFiltro);
      carregarLancamentos(novoFiltro);
      carregarDashboard();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
  };

  const salvarConta = async (e) => {
    e.preventDefault();
    try {
      if (formConta.id) await api.put('/financeiro/contas/' + formConta.id, formConta);
      else await api.post('/financeiro/contas', formConta);
      setModalConta(false); setFormConta({});
      carregarContas(); carregarDashboard();
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
  };

  const salvarNovoFornecedor = async () => {
    if (!novoFornecedor.nome) { alert('Digite o nome'); return; }
    try {
      const r = await api.post('/fornecedores', { nome: novoFornecedor.nome, cpf_cnpj: novoFornecedor.cpf_cnpj });
      await api.get('/fornecedores').then(res => setFornecedores(res.data));
      setV('fornecedor_id', String(r.data.id));
      setNovoFornecedor({ show: false, nome: '', cpf_cnpj: '' });
    } catch(e) { alert('Erro ao criar fornecedor'); }
  };

  const salvarNovaCategoria = async () => {
    if (!novaCategoria.nome) { alert('Digite o nome'); return; }
    try {
      const r = await api.post('/financeiro/categorias', { nome: novaCategoria.nome, tipo: novaCategoria.tipo, cor: novaCategoria.cor });
      await carregarCategorias();
      setV('categoria_id', String(r.data.id));
      setNovaCategoria({ show: false, nome: '', tipo: 'despesa', cor: '#6B7A8D' });
    } catch (err) { alert('Erro'); }
  };

  const salvarTransferencia = async () => {
    const { conta_origem, conta_destino, valor, data, descricao } = formTransf;
    if (!conta_origem || !conta_destino || !valor || !data) { alert('Preencha todos os campos'); return; }
    if (conta_origem === conta_destino) { alert('Origem e destino não podem ser iguais'); return; }
    try {
      const dataHoje = data || new Date().toISOString().split('T')[0];
      // Saída da conta origem
      await api.post('/financeiro/lancamentos', {
        tipo: 'despesa', descricao: descricao + ' (saída)',
        valor, data_vencimento: dataHoje, data_pagamento: dataHoje,
        status: 'pago', conta_id: conta_origem, total_parcelas: 1, modo_lancamento: 'simples'
      });
      // Entrada na conta destino
      await api.post('/financeiro/lancamentos', {
        tipo: 'receita', descricao: descricao + ' (entrada)',
        valor, data_vencimento: dataHoje, data_pagamento: dataHoje,
        status: 'pago', conta_id: conta_destino, total_parcelas: 1, modo_lancamento: 'simples'
      });
      setModalTransf(false);
      setFormTransf({ conta_origem: '', conta_destino: '', valor: '', data: '', descricao: 'Transferência entre contas' });
      carregarLancamentos(); carregarDashboard();
      alert('Transferência registrada com sucesso!');
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
  };

  const pagarParcial = async () => {
    try {
      const v = parseFloat(valorParcial);
      if (!v || v <= 0) { alert('Informe o valor recebido'); return; }
      if (v > parseFloat(modalParcial.valor)) { alert('Valor maior que o lançamento'); return; }
      await api.put('/financeiro/lancamentos/' + modalParcial.id + '/pagar-parcial', {
        valor_recebido: v,
        data_pagamento: form.data_pagamento || hoje,
        conta_id: form.conta_id_pag || modalParcial.conta_id || null
      });
      setModalParcial(null); setValorParcial(''); setForm({});
      carregarLancamentos(); carregarDashboard();
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
  };

  const abrirDividir = (l) => {
    // Parsear formas existentes da descrição
    const formas = l.descricao ? l.descricao.split('+').map(f => {
      const match = f.trim().match(/^(.+?)\s*\(R\$\s*([\d.,]+)\)$/);
      if (match) return { forma: match[1].trim(), valor: match[2].replace('.','').replace(',','.'), conta_id: l.conta_id ? String(l.conta_id) : '' };
      return { forma: f.trim(), valor: '', conta_id: l.conta_id ? String(l.conta_id) : '' };
    }) : [{ forma: '', valor: '', conta_id: '' }];
    setDivisoes(formas.length > 1 ? formas : [{ forma: '', valor: '', conta_id: '' }, { forma: '', valor: '', conta_id: '' }]);
    setModalDividir(l);
  };

  const salvarDivisao = async () => {
    const validas = divisoes.filter(d => d.forma && d.valor);
    if (validas.length < 2) { alert('Adicione pelo menos 2 formas de pagamento com valores'); return; }
    try {
      // Cancelar lançamento original
      await api.delete('/financeiro/lancamentos/' + modalDividir.id);
      // Criar um lançamento para cada forma
      for (const d of validas) {
        await api.post('/financeiro/lancamentos', {
          tipo: modalDividir.tipo,
          descricao: modalDividir.descricao + ' — ' + d.forma,
          valor: d.valor,
          data_vencimento: modalDividir.data_vencimento,
          data_pagamento: modalDividir.data_pagamento,
          status: modalDividir.status,
          conta_id: d.conta_id || null,
          categoria_id: modalDividir.categoria_id,
          venda_id: modalDividir.venda_id,
          total_parcelas: 1,
          modo_lancamento: 'simples',
        });
      }
      setModalDividir(null);
      carregarLancamentos(); carregarDashboard();
      alert('Pagamento dividido em ' + validas.length + ' lançamentos!');
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
  };

  const importarOFX = async (e) => {
    const file = e.target.files[0];
    if (!file || !ofxContaId) { alert('Selecione a conta e o arquivo'); return; }
    setOfxLoading(true);
    try {
      const fd = new FormData();
      fd.append('arquivo', file); fd.append('conta_id', ofxContaId);
      const r = await api.post('/financeiro/importar-ofx', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setOfxTransacoes(r.data.transacoes.map(t => ({ ...t, ignorar: t.ja_importado })));
    } catch (err) { alert('Erro ao importar'); }
    finally { setOfxLoading(false); }
  };

  const confirmarOFX = async () => {
    try {
      // Enriquecer transações com dados de vínculo e categorização
      const transacoesEnriquecidas = ofxTransacoes.map((t, i) => ({
        ...t,
        modo: modoLinha[i] || null,
        ...(dadosLinha[i] || {}),
      }));
      const r = await api.post('/financeiro/confirmar-ofx', { conta_id: ofxContaId, transacoes: transacoesEnriquecidas });
      alert(`${r.data.importados} lançamentos importados!`);
      setOfxTransacoes([]); setModoLinha({}); setDadosLinha({}); setBuscaCliente({});
      if (ofxRef.current) ofxRef.current.value = '';
      carregarLancamentos(); carregarDashboard();
    } catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
  };

  const inp = (label, campo, tipo, opts) => (
    <div style={{ marginBottom: '12px' }}>
      <label style={lbl}>{label}</label>
      {opts ? (
        <select value={form[campo] || ''} onChange={e => setV(campo, e.target.value)} style={inpStyle}>
          <option value=''>Selecione</option>
          {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
        </select>
      ) : (
        <input type={tipo || 'text'} value={form[campo] || ''} onChange={e => setV(campo, e.target.value)} style={inpStyle} />
      )}
    </div>
  );

  // Filtrar lançamentos localmente
  const filtrados = lancamentos.filter(l => {
    if (!busca) return true;
    const b = busca.toLowerCase();
    return (l.descricao || '').toLowerCase().includes(b) || (l.categoria_nome || '').toLowerCase().includes(b) || (l.conta_nome || '').toLowerCase().includes(b) || (l.fornecedor_nome || '').toLowerCase().includes(b);
  });

  const toggleSel = (id) => setSelecionados(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  const toggleTodos = () => setSelecionados(s => s.length === filtrados.length ? [] : filtrados.map(l => l.id));

  const statusBadge = (status, venc) => {
    const atrasado = status === 'pendente' && venc && String(venc).split('T')[0] < hoje;
    const cfg = status === 'pago' ? { bg: '#EAF5EE', c: '#2D7D4F', t: '✓ Pago' } : atrasado ? { bg: '#FDECEA', c: '#C0392B', t: '⚠ Vencido' } : { bg: '#FFF3E0', c: '#B06000', t: 'Pendente' };
    return <span style={{ background: cfg.bg, color: cfg.c, padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{cfg.t}</span>;
  };

  const modo = form.modo_lancamento || 'simples';
  const valorParcela = parseFloat(form.valor_parcela || 0);
  const numParcelas = parseInt(form.total_parcelas || 1);

  const tabelaJSX = (
    <div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
        <input placeholder='Buscar por descrição, categoria, conta ou fornecedor...' value={busca}
          onChange={e => setBusca(e.target.value)}
          style={{ flex: 1, padding: '8px 12px', background: '#fff', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", color: '#1C2533', outline: 'none' }} />
        {selecionados.length > 0 && (
          <button onClick={cancelarLote}
            style={{ padding: '8px 16px', background: '#C0392B', border: 'none', color: '#fff', borderRadius: '7px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '700', fontSize: '13px', whiteSpace: 'nowrap' }}>
            × Cancelar {selecionados.length} selecionado(s)
          </button>
        )}
      </div>
      <div style={card}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ ...th, width: '32px' }}>
                <input type='checkbox' onChange={toggleTodos} checked={filtrados.length > 0 && selecionados.length === filtrados.length} />
              </th>
              {['Fornecedor', 'Descrição', 'Categoria', 'Vencimento', 'Pago em', 'Valor', 'Conta', 'Status', ''].map(h => <th key={h} style={th}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 && <tr><td colSpan={9} style={{ ...td, textAlign: 'center', color: '#9AA3AE', padding: '32px' }}>Nenhum lançamento encontrado</td></tr>}
            {filtrados.map(l => (
              <tr key={l.id} style={{ background: selecionados.includes(l.id) ? '#E6F1FB' : 'transparent' }}>
                <td style={td}><input type='checkbox' checked={selecionados.includes(l.id)} onChange={() => toggleSel(l.id)} /></td>
                <td style={{ ...td, color: '#6B7A8D', fontSize: '12px' }}>{l.fornecedor_nome || '—'}</td>
                <td style={{ ...td, fontWeight: '500' }}>
                  {l.descricao}
                  {l.total_parcelas > 1 && <span style={{ fontSize: '10px', color: '#9AA3AE', marginLeft: '6px' }}>{l.parcela_atual}/{l.total_parcelas}</span>}
                </td>
                <td style={td}>
                  {l.categoria_nome && <span style={{ background: (l.categoria_cor || '#6B7A8D') + '22', color: l.categoria_cor || '#6B7A8D', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{l.categoria_nome}</span>}
                </td>
                <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: '12px', color: '#6B7A8D' }}>{fmtData(l.data_vencimento)}</td>
                <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: '12px', color: l.data_pagamento ? '#2D7D4F' : '#9AA3AE' }}>{l.data_pagamento ? fmtData(l.data_pagamento) : '—'}</td>
                <td style={{ ...td, fontFamily: "'DM Mono',monospace", fontSize: '13px', fontWeight: '700', color: l.tipo === 'receita' ? '#2D7D4F' : '#C0392B' }}>
                  {l.tipo === 'receita' ? '+' : '-'}{fmt(l.valor)}
                  {l.venda_saldo_aberto > 0 && (
                    <div style={{ fontSize: '10px', color: '#E67E22', fontWeight: '700', marginTop: '2px' }}>
                      ⚠ Saldo: {fmt(l.venda_saldo_aberto)}
                    </div>
                  )}
                </td>
                <td style={{ ...td, color: '#6B7A8D', fontSize: '12px' }}>{l.conta_nome || '—'}</td>
                <td style={td}>{statusBadge(l.status, l.data_vencimento)}</td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {l.status === 'pendente' && (
                      <button onClick={() => { setModalPagar(l); setForm({ data_pagamento: hoje }); }}
                        style={{ padding: '3px 8px', background: '#EAF5EE', border: 'none', color: '#2D7D4F', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                        Pagar
                      </button>
                    )}
                    <button onClick={() => { setForm({ ...l, conta_id: l.conta_id ? String(l.conta_id) : '', categoria_id: l.categoria_id ? String(l.categoria_id) : '', fornecedor_id: l.fornecedor_id ? String(l.fornecedor_id) : '' }); setModalLanc(true); }}
                      style={{ padding: '3px 8px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#1A3A5C', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      Editar
                    </button>
                    <button onClick={() => { setModalParcial(l); setValorParcial(''); }}
                        style={{ padding: '3px 8px', background: 'transparent', border: '1px solid #E67E22', color: '#E67E22', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif", whiteSpace: 'nowrap' }}>
                        ½ Parcial
                      </button>
                      <button onClick={() => abrirDividir(l)}
                      style={{ padding: '3px 8px', background: '#E6F1FB', border: 'none', color: '#1A3A5C', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>
                      ÷ Dividir
                    </button>
                    <button onClick={() => cancelarUm(l.id)}
                      style={{ padding: '3px 8px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                      ×
                    </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const filtroJSX = (tipoFixo) => (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', flexWrap: 'wrap', alignItems: 'center' }}>
      <input type='date' value={filtro.inicio} onChange={e => setFiltro(f => ({ ...f, inicio: e.target.value, tipo: tipoFixo || f.tipo }))} style={{ ...inpStyle, width: 'auto' }} />
      <input type='date' value={filtro.fim} onChange={e => setFiltro(f => ({ ...f, fim: e.target.value, tipo: tipoFixo || f.tipo }))} style={{ ...inpStyle, width: 'auto' }} />
      <select value={filtro.status} onChange={e => setFiltro(f => ({ ...f, status: e.target.value, tipo: tipoFixo || f.tipo }))} style={{ ...inpStyle, width: 'auto' }}>
        <option value=''>Todos os status</option>
        <option value='pendente'>Pendente</option>
        <option value='pago'>{tipoFixo === 'receita' ? 'Recebido' : 'Pago'}</option>
      </select>
      {!tipoFixo && (
        <select value={filtro.conta_id} onChange={e => setFiltro(f => ({ ...f, conta_id: e.target.value }))} style={{ ...inpStyle, width: 'auto' }}>
          <option value=''>Todas as contas</option>
          {contas.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      )}
      <button onClick={() => carregarLancamentos({ ...filtro, tipo: tipoFixo || filtro.tipo })}
        style={{ padding: '8px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '7px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", whiteSpace: 'nowrap' }}>
        Buscar
      </button>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>Financeiro</div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setModalTransf(true)}
            style={{ padding: '9px 18px', background: 'transparent', border: '1px solid rgba(26,58,92,0.3)', color: '#1A3A5C', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
            ⇄ Transferência
          </button>
          <button onClick={() => { setForm({ tipo: aba === 'A Receber' ? 'receita' : 'despesa', total_parcelas: 1, data_vencimento: hoje, modo_lancamento: 'simples' }); setModalLanc(true); }}
            style={{ padding: '9px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
            + Novo Lançamento
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '4px', marginBottom: '18px', borderBottom: '1px solid rgba(26,58,92,0.1)' }}>
        {ABAS.map(a => (
          <button key={a} onClick={() => setAba(a)}
            style={{ padding: '8px 14px', background: 'none', border: 'none', borderBottom: aba === a ? '2px solid #1A3A5C' : '2px solid transparent', color: aba === a ? '#1A3A5C' : '#6B7A8D', cursor: 'pointer', fontWeight: aba === a ? '700' : '400', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", marginBottom: '-1px', whiteSpace: 'nowrap' }}>
            {a}
          </button>
        ))}
      </div>

      {/* DASHBOARD */}
      {aba === 'Dashboard' && dashboard && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: '12px', marginBottom: '14px' }}>
            {dashboard.contas.map(c => (
              <div key={c.id} style={{ ...card, borderLeft: `3px solid ${parseFloat(c.saldo_atual) >= 0 ? '#2D7D4F' : '#C0392B'}` }}>
                <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', marginBottom: '6px' }}>{c.nome}</div>
                <div style={{ fontSize: '20px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: parseFloat(c.saldo_atual) >= 0 ? '#2D7D4F' : '#C0392B' }}>{fmt(c.saldo_atual)}</div>
              </div>
            ))}
            <div style={{ ...card, background: '#1A3A5C', borderLeft: '3px solid #7FB8F5' }}>
              <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.6)', fontWeight: '600', textTransform: 'uppercase', marginBottom: '6px' }}>Saldo Total</div>
              <div style={{ fontSize: '20px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: '#fff' }}>{fmt(dashboard.saldo_total)}</div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '14px' }}>
            {[
              { label: 'A Receber (30d)', val: dashboard.a_receber.total, qtd: dashboard.a_receber.qtd, c: '#2D7D4F' },
              { label: 'A Pagar (30d)', val: dashboard.a_pagar.total, qtd: dashboard.a_pagar.qtd, c: '#C0392B' },
              { label: 'Vencidos', val: dashboard.vencidos.total, qtd: dashboard.vencidos.qtd, c: '#E67E22' },
              { label: 'Resultado do mês', val: dashboard.resultado_mes, qtd: null, c: parseFloat(dashboard.resultado_mes) >= 0 ? '#2D7D4F' : '#C0392B' },
            ].map(item => (
              <div key={item.label} style={card}>
                <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', marginBottom: '6px' }}>{item.label}</div>
                <div style={{ fontSize: '18px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: item.c }}>{fmt(item.val)}</div>
                {item.qtd !== null && <div style={{ fontSize: '11px', color: '#9AA3AE', marginTop: '3px' }}>{item.qtd} lançamentos</div>}
              </div>
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
            <div style={card}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Mês atual</div>
              {[{ label: '↑ Receitas', val: dashboard.receita_mes, bg: '#EAF5EE', c: '#2D7D4F' }, { label: '↓ Despesas', val: dashboard.despesa_mes, bg: '#FDECEA', c: '#C0392B' }].map(item => (
                <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: item.bg, borderRadius: '8px', marginBottom: '8px' }}>
                  <span style={{ fontSize: '13px', color: item.c, fontWeight: '600' }}>{item.label}</span>
                  <span style={{ fontFamily: "'DM Mono',monospace", fontWeight: '700', color: item.c }}>{fmt(item.val)}</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: '#1A3A5C', borderRadius: '8px' }}>
                <span style={{ fontSize: '13px', color: '#fff', fontWeight: '600' }}>= Resultado</span>
                <span style={{ fontFamily: "'DM Mono',monospace", fontWeight: '700', color: parseFloat(dashboard.resultado_mes) >= 0 ? '#7DF5B8' : '#FF8080' }}>{fmt(dashboard.resultado_mes)}</span>
              </div>
            </div>
            <div style={card}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Próximos 30 dias</div>
              <div style={{ maxHeight: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {dashboard.proximos_vencimentos.length === 0 && <div style={{ color: '#9AA3AE', fontSize: '13px' }}>Sem vencimentos</div>}
                {dashboard.proximos_vencimentos.map(l => (
                  <div key={l.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: '#F4F6F9', borderRadius: '7px' }}>
                    <div><div style={{ fontSize: '12px', fontWeight: '500', color: '#1C2533' }}>{l.descricao}</div><div style={{ fontSize: '11px', color: '#9AA3AE' }}>{fmtData(l.data_vencimento)}</div></div>
                    <span style={{ fontFamily: "'DM Mono',monospace", fontSize: '13px', fontWeight: '700', color: l.tipo === 'receita' ? '#2D7D4F' : '#C0392B' }}>{l.tipo === 'receita' ? '+' : '-'}{fmt(l.valor)}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#1C2533' }}>A Receber no mês</div>
                <span style={{ background: '#EAF5EE', color: '#2D7D4F', padding: '2px 8px', borderRadius: '20px', fontSize: '11px', fontWeight: '700' }}>{fmt(dashboard.a_receber.total)}</span>
              </div>
              <div style={{ maxHeight: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {(dashboard.a_receber_lista || []).length === 0 && <div style={{ color: '#9AA3AE', fontSize: '13px' }}>Nenhum recebimento pendente</div>}
                {(dashboard.a_receber_lista || []).map(l => (
                  <div key={l.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: '#EAF5EE', borderRadius: '7px', borderLeft: '3px solid #2D7D4F' }}>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '500', color: '#1C2533' }}>{l.descricao}</div>
                      <div style={{ fontSize: '11px', color: '#9AA3AE' }}>{fmtData(l.data_vencimento)}</div>
                      {l.venda_saldo_aberto > 0 && <div style={{ fontSize: '11px', color: '#E67E22', fontWeight: '700' }}>Saldo: {fmt(l.venda_saldo_aberto)}</div>}
                    </div>
                    <span style={{ fontFamily: "'DM Mono',monospace", fontSize: '13px', fontWeight: '700', color: '#2D7D4F' }}>+{fmt(l.valor)}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {aba === 'A Pagar' && <div>{filtroJSX('despesa')}{tabelaJSX}</div>}
      {aba === 'A Receber' && <div>{filtroJSX('receita')}{tabelaJSX}</div>}
      {aba === 'Lançamentos' && <div>{filtroJSX()}{tabelaJSX}</div>}

      {/* BANCOS */}
      {aba === 'Bancos' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '14px' }}>
            <button onClick={() => { setFormConta({}); setModalConta(true); }}
              style={{ padding: '9px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              + Nova Conta
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: '14px' }}>
            {contas.map(c => (
              <div key={c.id} style={{ ...card, borderLeft: `3px solid ${parseFloat(c.saldo_atual) >= 0 ? '#2D7D4F' : '#C0392B'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#1C2533' }}>{c.nome}</div>
                    <div style={{ fontSize: '12px', color: '#9AA3AE' }}>{c.banco}{c.agencia ? ' · Ag: ' + c.agencia : ''}{c.conta ? ' · CC: ' + c.conta : ''}</div>
                    {c.data_saldo_inicial && <div style={{ fontSize: '11px', color: '#9AA3AE', marginTop: '2px' }}>Ref.: {fmtData(c.data_saldo_inicial)}</div>}
                  </div>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button onClick={() => abrirExtrato(c)}
                      style={{ padding: "4px 10px", background: "#E6F1FB", border: "none", color: "#1A3A5C", borderRadius: "6px", cursor: "pointer", fontSize: "11px", fontWeight: "600" }}>Extrato</button>
                    <button onClick={() => { setFormConta(c); setModalConta(true); }}
                      style={{ padding: "4px 10px", background: "transparent", border: "1px solid rgba(26,58,92,0.2)", color: "#1A3A5C", borderRadius: "6px", cursor: "pointer", fontSize: "11px" }}>Editar</button>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div><div style={{ fontSize: '11px', color: '#9AA3AE', marginBottom: '2px' }}>Saldo atual</div><div style={{ fontSize: '22px', fontWeight: '700', fontFamily: "'DM Mono',monospace", color: parseFloat(c.saldo_atual) >= 0 ? '#2D7D4F' : '#C0392B' }}>{fmt(c.saldo_atual)}</div></div>
                  <div style={{ textAlign: 'right' }}><div style={{ fontSize: '11px', color: '#9AA3AE', marginBottom: '2px' }}>Saldo inicial</div><div style={{ fontSize: '14px', fontFamily: "'DM Mono',monospace", color: '#6B7A8D' }}>{fmt(c.saldo_inicial)}</div></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* IMPORTAR OFX */}
      {aba === 'Importar OFX' && (
        <div>
          <div style={{ ...card, marginBottom: '14px' }}>
            <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Importar extrato OFX</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px', marginBottom: '8px' }}>
              <div><label style={lbl}>Conta bancária</label>
                <select value={ofxContaId} onChange={e => setOfxContaId(e.target.value)} style={inpStyle}>
                  <option value=''>Selecione</option>
                  {contas.map(ct => <option key={ct.id} value={ct.id}>{ct.nome}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Arquivo OFX</label>
                <input type='file' accept='.ofx,.OFX' ref={ofxRef} onChange={importarOFX} style={{ ...inpStyle, padding: '6px 10px' }} />
              </div>
            </div>
            {ofxLoading && <div style={{ fontSize: '13px', color: '#9AA3AE' }}>Processando...</div>}
          </div>
          {ofxTransacoes.length > 0 && (
            <div style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533' }}>
                  {ofxTransacoes.length} transações · <span style={{ color: '#1E5FA5' }}>{ofxTransacoes.filter(t => !t.ignorar).length} serão importadas</span>
                </div>
                <button onClick={confirmarOFX} style={{ padding: '9px 18px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>✓ Confirmar importação</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {ofxTransacoes.map((t, i) => {
                  const modo = modoLinha[i];
                  const dados = dadosLinha[i] || {};
                  const clientesFiltrados = clientes.filter(cl =>
                    !buscaCliente[i] || cl.nome?.toLowerCase().includes((buscaCliente[i] || '').toLowerCase())
                  );
                  const vendasCliente = dados.cliente_id ? vendas.filter(v => String(v.cliente_id) === String(dados.cliente_id)) : [];
                  return (
                    <div key={i} style={{ border: `1px solid ${t.ignorar ? 'rgba(26,58,92,0.08)' : modo ? '#1A3A5C' : 'rgba(26,58,92,0.12)'}`, borderRadius: '8px', padding: '12px 14px', opacity: t.ignorar ? 0.4 : 1, background: modo ? '#F0F5FF' : '#fff' }}>
                      {/* Linha principal */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input type='checkbox' checked={!t.ignorar} disabled={t.ja_importado}
                          onChange={e => setOfxTransacoes(ts => ts.map((x, idx) => idx === i ? { ...x, ignorar: !e.target.checked } : x))} />
                        <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '12px', color: '#6B7A8D', whiteSpace: 'nowrap' }}>{fmtData(t.data)}</div>
                        <div style={{ flex: 1, fontSize: '12px', color: '#1C2533', fontWeight: '500' }}>{t.memo}</div>
                        <span style={{ color: t.tipo === 'receita' ? '#2D7D4F' : '#C0392B', fontWeight: '600', fontSize: '12px', whiteSpace: 'nowrap' }}>{t.tipo}</span>
                        <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '13px', fontWeight: '700', color: t.tipo === 'receita' ? '#2D7D4F' : '#C0392B', whiteSpace: 'nowrap' }}>{fmt(t.valor)}</div>
                        {t.ja_importado
                          ? <span style={{ color: '#9AA3AE', fontSize: '11px', whiteSpace: 'nowrap' }}>Já importado</span>
                          : !t.ignorar && (
                            <div style={{ display: 'flex', gap: '4px' }}>
                              <button onClick={() => setModoLinha(m => ({ ...m, [i]: m[i] === 'venda' ? null : 'venda' }))}
                                style={{ padding: '3px 8px', background: modo === 'venda' ? '#1A3A5C' : '#E6F1FB', border: 'none', color: modo === 'venda' ? '#fff' : '#1A3A5C', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600', whiteSpace: 'nowrap' }}>
                                🔗 Vincular venda
                              </button>
                              <button onClick={() => setModoLinha(m => ({ ...m, [i]: m[i] === 'manual' ? null : 'manual' }))}
                                style={{ padding: '3px 8px', background: modo === 'manual' ? '#1A3A5C' : '#F4F6F9', border: 'none', color: modo === 'manual' ? '#fff' : '#6B7A8D', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif", whiteSpace: 'nowrap' }}>
                                ✏️ Categorizar
                              </button>
                            </div>
                          )
                        }
                      </div>

                      {/* Modo: Vincular a uma venda */}
                      {modo === 'venda' && !t.ignorar && (
                        <div style={{ marginTop: '10px', padding: '10px', background: '#E6F1FB', borderRadius: '7px' }}>
                          <div style={{ fontSize: '11px', fontWeight: '600', color: '#1A3A5C', marginBottom: '8px', textTransform: 'uppercase' }}>Vincular a uma venda</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                            <div>
                              <label style={{ ...lbl, color: '#1A3A5C' }}>Buscar cliente</label>
                              <input placeholder='Nome do cliente...' value={buscaCliente[i] || ''}
                                onChange={e => setBuscaCliente(b => ({ ...b, [i]: e.target.value }))}
                                style={{ ...inpStyle, background: '#fff' }} />
                              {buscaCliente[i] && clientesFiltrados.length > 0 && (
                                <div style={{ background: '#fff', border: '1px solid rgba(26,58,92,0.15)', borderRadius: '6px', maxHeight: '120px', overflowY: 'auto', marginTop: '2px' }}>
                                  {clientesFiltrados.slice(0, 5).map(cl => (
                                    <div key={cl.id} onClick={() => { setDadosLinha(d => ({ ...d, [i]: { ...d[i], cliente_id: cl.id, cliente_nome: cl.nome } })); setBuscaCliente(b => ({ ...b, [i]: cl.nome })); }}
                                      style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '0.5px solid rgba(26,58,92,0.07)' }}
                                      onMouseOver={e => e.target.style.background='#F4F6F9'}
                                      onMouseOut={e => e.target.style.background='#fff'}>
                                      {cl.nome} — {cl.cpf_cnpj}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            <div>
                              <label style={{ ...lbl, color: '#1A3A5C' }}>Venda do cliente</label>
                              <select value={dados.venda_id || ''} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], venda_id: e.target.value } }))}
                                style={{ ...inpStyle, background: '#fff' }} disabled={!dados.cliente_id}>
                                <option value=''>Selecione a venda</option>
                                {vendasCliente.map(v => (
                                  <option key={v.id} value={v.id}>#{v.id} — {v.marca} {v.modelo} — Total: {fmt(v.valor_final)} | Recebido: {fmt(v.valor_recebido||0)} | Saldo: {fmt(parseFloat(v.valor_final) - parseFloat(v.valor_recebido||0))}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {dados.venda_id && (() => {
                            const venda = vendasCliente.find(v => String(v.id) === String(dados.venda_id));
                            const saldoAtual = venda ? parseFloat(venda.valor_final) - parseFloat(venda.valor_recebido||0) : 0;
                            const saldoApos = saldoAtual - parseFloat(t.valor||0);
                            return (
                              <div style={{ marginTop: '8px', padding: '8px 12px', background: '#EAF5EE', borderRadius: '7px', fontSize: '12px' }}>
                                <div style={{ color: '#2D7D4F', fontWeight: '700' }}>✓ Vinculado à venda #{dados.venda_id}</div>
                                <div style={{ display: 'flex', gap: '16px', marginTop: '4px', color: '#6B7A8D' }}>
                                  <span>Total: <b>{fmt(venda?.valor_final)}</b></span>
                                  <span>Recebido: <b>{fmt(venda?.valor_recebido||0)}</b></span>
                                  <span>Este PIX: <b style={{ color: '#2D7D4F' }}>+{fmt(t.valor)}</b></span>
                                  <span>Saldo após: <b style={{ color: saldoApos > 0 ? '#E67E22' : '#2D7D4F' }}>{fmt(saldoApos > 0 ? saldoApos : 0)}</b></span>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      )}

                      {/* Modo: Categorizar manualmente */}
                      {modo === 'manual' && !t.ignorar && (
                        <div style={{ marginTop: '10px', padding: '10px', background: '#F4F6F9', borderRadius: '7px' }}>
                          <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7A8D', marginBottom: '8px', textTransform: 'uppercase' }}>Categorizar lançamento</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px' }}>
                            <div>
                              <label style={lbl}>Descrição</label>
                              <input value={dados.descricao || t.memo} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], descricao: e.target.value } }))} style={inpStyle} />
                            </div>
                            <div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <label style={{ ...lbl, marginBottom: 0 }}>Categoria</label>
                                <button type='button' onClick={() => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _novaCategoria: !d[i]?._novaCategoria, _nomeCategoria: '', _tipoCategoria: t.tipo } }))}
                                  style={{ fontSize: '11px', color: '#1E5FA5', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>+ Nova</button>
                              </div>
                              {dados._novaCategoria ? (
                                <div style={{ display: 'flex', gap: '4px' }}>
                                  <input placeholder='Nome...' value={dados._nomeCategoria || ''} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _nomeCategoria: e.target.value } }))} style={{ ...inpStyle, flex: 1 }} />
                                  <button type='button' onClick={async () => {
                                    if (!dados._nomeCategoria) return;
                                    try {
                                      const r = await api.post('/financeiro/categorias', { nome: dados._nomeCategoria, tipo: t.tipo, cor: '#6B7A8D' });
                                      await carregarCategorias();
                                      setDadosLinha(d => ({ ...d, [i]: { ...d[i], categoria_id: String(r.data.id), _novaCategoria: false, _nomeCategoria: '' } }));
                                    } catch(e) { alert('Erro'); }
                                  }} style={{ padding: '0 10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600', whiteSpace: 'nowrap' }}>✓</button>
                                  <button type='button' onClick={() => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _novaCategoria: false } }))} style={{ padding: '0 8px', background: '#F4F6F9', border: 'none', color: '#6B7A8D', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>×</button>
                                </div>
                              ) : (
                                <select value={dados.categoria_id || ''} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], categoria_id: e.target.value } }))} style={inpStyle}>
                                  <option value=''>Selecione</option>
                                  {categorias.filter(cat => cat.tipo === t.tipo || cat.tipo === 'ambos').map(cat => (
                                    <option key={cat.id} value={cat.id}>{cat.nome}</option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <label style={{ ...lbl, marginBottom: 0 }}>Fornecedor</label>
                                <button type='button' onClick={() => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _novoForn: !d[i]?._novoForn, _nomeForn: '' } }))}
                                  style={{ fontSize: '11px', color: '#1E5FA5', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>+ Novo</button>
                              </div>
                              {dados._novoForn ? (
                                <div style={{ display: 'flex', gap: '4px' }}>
                                  <input placeholder='Nome...' value={dados._nomeForn || ''} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _nomeForn: e.target.value } }))} style={{ ...inpStyle, flex: 1 }} />
                                  <button type='button' onClick={async () => {
                                    if (!dados._nomeForn) return;
                                    try {
                                      const r = await api.post('/fornecedores', { nome: dados._nomeForn });
                                      await api.get('/fornecedores').then(res => setFornecedores(res.data));
                                      setDadosLinha(d => ({ ...d, [i]: { ...d[i], fornecedor_id: String(r.data.id), _novoForn: false, _nomeForn: '' } }));
                                    } catch(e) { alert('Erro'); }
                                  }} style={{ padding: '0 10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600', whiteSpace: 'nowrap' }}>Criar</button>
                                  <button type='button' onClick={() => setDadosLinha(d => ({ ...d, [i]: { ...d[i], _novoForn: false } }))} style={{ padding: '0 8px', background: '#F4F6F9', border: 'none', color: '#6B7A8D', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>x</button>
                                </div>
                              ) : (
                                <select value={dados.fornecedor_id || ''} onChange={e => setDadosLinha(d => ({ ...d, [i]: { ...d[i], fornecedor_id: e.target.value } }))} style={inpStyle}>
                                  <option value=''>Nenhum</option>
                                  {fornecedores.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                </select>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}

      {/* MODAL LANÇAMENTO */}
      {modalLanc && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '580px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>{form.id ? 'Editar' : 'Novo'} Lançamento</h3>
              <button onClick={() => { setModalLanc(false); setForm({}); }} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <form onSubmit={salvarLancamento}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                {inp('Tipo', 'tipo', 'text', [{ v: 'despesa', l: 'Despesa' }, { v: 'receita', l: 'Receita' }])}
                {inp('Data vencimento', 'data_vencimento', 'date')}
              </div>
              {inp('Descrição', 'descricao')}
              <div style={{ marginBottom: '12px' }}>
                <label style={lbl}>Tipo de lançamento</label>
                <div style={{ display: 'flex', gap: '6px' }}>
                  {[{ v: 'simples', l: 'Simples' }, { v: 'parcelado', l: 'Parcelado' }, { v: 'fixo', l: 'Fixo recorrente' }].map(opt => (
                    <button key={opt.v} type='button' onClick={() => setV('modo_lancamento', opt.v)}
                      style={{ flex: 1, padding: '7px 4px', background: modo === opt.v ? '#1A3A5C' : '#F4F6F9', border: 'none', color: modo === opt.v ? '#fff' : '#6B7A8D', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: modo === opt.v ? '700' : '400' }}>
                      {opt.l}
                    </button>
                  ))}
                </div>
              </div>
              {modo === 'simples' && (
                <div style={{ marginBottom: '12px' }}><label style={lbl}>Valor</label><input type='number' step='0.01' value={form.valor || ''} onChange={e => setV('valor', e.target.value)} style={inpStyle} /></div>
              )}
              {modo === 'parcelado' && (
                <div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                    <div style={{ marginBottom: '12px' }}><label style={lbl}>Valor total</label><input type='number' step='0.01' value={form.valor || ''} onChange={e => setV('valor', e.target.value)} style={inpStyle} /></div>
                    <div style={{ marginBottom: '12px' }}><label style={lbl}>Nº parcelas</label><input type='number' min='2' value={form.total_parcelas || ''} onChange={e => setV('total_parcelas', e.target.value)} style={inpStyle} /></div>
                  </div>
                  {numParcelas > 1 && parseFloat(form.valor) > 0 && (
                    <div style={{ background: '#E6F1FB', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px', fontSize: '13px', color: '#1E5FA5' }}>
                      💡 {numParcelas}× de <strong>{fmt(parseFloat(form.valor || 0) / numParcelas)}</strong> · Total: {fmt(form.valor)}
                    </div>
                  )}
                </div>
              )}
              {modo === 'fixo' && (
                <div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                    <div style={{ marginBottom: '12px' }}><label style={lbl}>Valor por parcela</label><input type='number' step='0.01' value={form.valor_parcela || ''} onChange={e => setV('valor_parcela', e.target.value)} style={inpStyle} /></div>
                    <div style={{ marginBottom: '12px' }}><label style={lbl}>Nº parcelas</label><input type='number' min='1' value={form.total_parcelas || ''} onChange={e => setV('total_parcelas', e.target.value)} style={inpStyle} /></div>
                  </div>
                  {numParcelas >= 1 && valorParcela > 0 && (
                    <div style={{ background: '#EAF5EE', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px', fontSize: '13px', color: '#2D7D4F' }}>
                      💡 {numParcelas}× de <strong>{fmt(valorParcela)}</strong> · Total: <strong>{fmt(valorParcela * numParcelas)}</strong>
                    </div>
                  )}
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                {inp('Conta bancária', 'conta_id', 'text', contas.map(c => ({ v: String(c.id), l: c.nome })))}
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <label style={{ ...lbl, marginBottom: 0 }}>Categoria</label>
                    <button type='button' onClick={() => setNovaCategoria(n => ({ ...n, show: !n.show, tipo: form.tipo || 'despesa' }))}
                      style={{ fontSize: '11px', color: '#1E5FA5', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>+ Nova</button>
                  </div>
                  {novaCategoria.show ? (
                    <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '10px' }}>
                      <input placeholder='Nome da categoria' value={novaCategoria.nome} onChange={e => setNovaCategoria(n => ({ ...n, nome: e.target.value }))} style={{ ...inpStyle, marginBottom: '6px' }} />
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <select value={novaCategoria.tipo} onChange={e => setNovaCategoria(n => ({ ...n, tipo: e.target.value }))} style={{ ...inpStyle, flex: 1 }}>
                          <option value='despesa'>Despesa</option><option value='receita'>Receita</option><option value='ambos'>Ambos</option>
                        </select>
                        <input type='color' value={novaCategoria.cor} onChange={e => setNovaCategoria(n => ({ ...n, cor: e.target.value }))} style={{ width: '36px', height: '36px', border: 'none', borderRadius: '6px', cursor: 'pointer', padding: '2px' }} />
                        <button type='button' onClick={salvarNovaCategoria} style={{ padding: '6px 10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>Criar</button>
                        <button type='button' onClick={() => setNovaCategoria(n => ({ ...n, show: false }))} style={{ padding: '6px 10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>×</button>
                      </div>
                    </div>
                  ) : (
                    <select value={form.categoria_id || ''} onChange={e => setV('categoria_id', e.target.value)} style={inpStyle}>
                      <option value=''>Selecione</option>
                      {categorias.filter(cat => !form.tipo || cat.tipo === form.tipo || cat.tipo === 'ambos').map(cat => (
                        <option key={cat.id} value={String(cat.id)}>{cat.nome}</option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              {/* Fornecedor com opcao de criar novo */}
              <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                  <label style={{ ...lbl, marginBottom: 0 }}>Fornecedor / Credor</label>
                  <button type='button' onClick={() => setNovoFornecedor(n => ({ ...n, show: !n.show, nome: '', cpf_cnpj: '' }))}
                    style={{ fontSize: '11px', color: '#1E5FA5', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>+ Novo</button>
                </div>
                {novoFornecedor.show ? (
                  <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '10px' }}>
                    <input placeholder='Nome do fornecedor' value={novoFornecedor.nome} onChange={e => setNovoFornecedor(n => ({ ...n, nome: e.target.value }))} style={{ ...inpStyle, marginBottom: '6px' }} />
                    <input placeholder='CPF/CNPJ (opcional)' value={novoFornecedor.cpf_cnpj} onChange={e => setNovoFornecedor(n => ({ ...n, cpf_cnpj: e.target.value }))} style={{ ...inpStyle, marginBottom: '6px' }} />
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button type='button' onClick={salvarNovoFornecedor} style={{ padding: '6px 10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '600' }}>Criar</button>
                      <button type='button' onClick={() => setNovoFornecedor(n => ({ ...n, show: false }))} style={{ padding: '6px 10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>x</button>
                    </div>
                  </div>
                ) : (
                  <select value={form.fornecedor_id || ''} onChange={e => setV('fornecedor_id', e.target.value)} style={inpStyle}>
                    <option value=''>Selecione</option>
                    {fornecedores.map(f => <option key={f.id} value={String(f.id)}>{f.nome}{f.cpf_cnpj ? ' — ' + f.cpf_cnpj : ''}</option>)}
                  </select>
                )}
              </div>
              {form.id && inp('Status', 'status', 'text', [{ v: 'pendente', l: 'Pendente' }, { v: 'pago', l: 'Pago' }])}
              {form.id && inp('Data pagamento', 'data_pagamento', 'date')}
              {inp('Observações', 'observacoes')}
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button type='button' onClick={() => { setModalLanc(false); setForm({}); }} style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Cancelar</button>
                <button type='submit' disabled={loading} style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>{loading ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL PAGAR */}
      {modalPagar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '380px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', marginBottom: '6px' }}>{modalPagar.tipo === 'receita' ? 'Confirmar recebimento' : 'Confirmar pagamento'}</h3>
            <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '20px' }}>{modalPagar.descricao} · {fmt(modalPagar.valor)}</div>
            <div style={{ marginBottom: '12px' }}><label style={lbl}>Data</label><input type='date' value={form.data_pagamento || hoje} onChange={e => setForm(f => ({ ...f, data_pagamento: e.target.value }))} style={inpStyle} /></div>
            {modalPagar.venda_id && parseFloat(modalPagar.venda_saldo_aberto) > 0 && (
              <div style={{ marginBottom: '16px', padding: '12px', background: '#FFF3E0', borderRadius: '8px' }}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#E67E22', marginBottom: '8px' }}>⚠ Venda com saldo em aberto</div>
                <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6B7A8D', marginBottom: '10px' }}>
                  <span>Total: <b>{fmt(modalPagar.valor)}</b></span>
                  <span>Já recebido: <b>{fmt(parseFloat(modalPagar.valor) - parseFloat(modalPagar.venda_saldo_aberto))}</b></span>
                  <span>Saldo: <b style={{ color: '#E67E22' }}>{fmt(modalPagar.venda_saldo_aberto)}</b></span>
                </div>
                <label style={lbl}>Valor recebido agora</label>
                <input type='number' step='0.01' value={form.valor_pago || modalPagar.venda_saldo_aberto}
                  onChange={e => setForm(f => ({ ...f, valor_pago: e.target.value }))} style={inpStyle} />
              </div>
            )}
            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Conta bancária</label>
              <select value={form.conta_id_pag || modalPagar.conta_id || ''} onChange={e => setForm(f => ({ ...f, conta_id_pag: e.target.value }))} style={inpStyle}>
                <option value=''>Selecione</option>
                {contas.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => { setModalPagar(null); setForm({}); }} style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Cancelar</button>
              <button onClick={pagarLancamento} style={{ flex: 1, padding: '10px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Confirmar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CONTA */}
      {modalConta && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '440px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>{formConta.id ? 'Editar' : 'Nova'} Conta</h3>
              <button onClick={() => { setModalConta(false); setFormConta({}); }} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <form onSubmit={salvarConta}>
              {[['Nome', 'nome'], ['Banco', 'banco'], ['Agência', 'agencia'], ['Conta', 'conta']].map(([l, campo]) => (
                <div key={campo} style={{ marginBottom: '12px' }}><label style={lbl}>{l}</label><input value={formConta[campo] || ''} onChange={e => setFormConta(f => ({ ...f, [campo]: e.target.value }))} style={inpStyle} /></div>
              ))}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px' }}>
                <div style={{ marginBottom: '12px' }}><label style={lbl}>Saldo inicial</label><input type='number' step='0.01' value={formConta.saldo_inicial || ''} onChange={e => setFormConta(f => ({ ...f, saldo_inicial: e.target.value }))} style={inpStyle} /></div>
                <div style={{ marginBottom: '12px' }}><label style={lbl}>Data de referência</label><input type='date' value={formConta.data_saldo_inicial || ''} onChange={e => setFormConta(f => ({ ...f, data_saldo_inicial: e.target.value }))} style={inpStyle} /></div>
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button type='button' onClick={() => { setModalConta(false); setFormConta({}); }} style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Cancelar</button>
                <button type='submit' style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* MODAL TRANSFERÊNCIA ENTRE CONTAS */}
      {modalTransf && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '460px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>⇄ Transferência entre contas</h3>
              <button onClick={() => setModalTransf(false)} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Descrição</label>
              <input value={formTransf.descricao} onChange={e => setFormTransf(f => ({ ...f, descricao: e.target.value }))} style={inpStyle} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px' }}>
              <div style={{ marginBottom: '12px' }}>
                <label style={lbl}>Conta origem (saída)</label>
                <select value={formTransf.conta_origem} onChange={e => setFormTransf(f => ({ ...f, conta_origem: e.target.value }))} style={inpStyle}>
                  <option value=''>Selecione</option>
                  {contas.map(ct => <option key={ct.id} value={String(ct.id)}>{ct.nome}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={lbl}>Conta destino (entrada)</label>
                <select value={formTransf.conta_destino} onChange={e => setFormTransf(f => ({ ...f, conta_destino: e.target.value }))} style={inpStyle}>
                  <option value=''>Selecione</option>
                  {contas.filter(ct => String(ct.id) !== formTransf.conta_origem).map(ct => <option key={ct.id} value={String(ct.id)}>{ct.nome}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px' }}>
              <div style={{ marginBottom: '16px' }}>
                <label style={lbl}>Valor</label>
                <input type='number' step='0.01' value={formTransf.valor} onChange={e => setFormTransf(f => ({ ...f, valor: e.target.value }))} style={inpStyle} />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={lbl}>Data</label>
                <input type='date' value={formTransf.data} onChange={e => setFormTransf(f => ({ ...f, data: e.target.value }))} style={inpStyle} />
              </div>
            </div>
            {formTransf.conta_origem && formTransf.conta_destino && formTransf.valor && (
              <div style={{ background: '#E6F1FB', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#1A3A5C' }}>
                {contas.find(ct => String(ct.id) === formTransf.conta_origem)?.nome} → {contas.find(ct => String(ct.id) === formTransf.conta_destino)?.nome} · {fmt(formTransf.valor)}
              </div>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalTransf(false)}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Cancelar
              </button>
              <button onClick={salvarTransferencia}
                style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                ⇄ Confirmar transferência
              </button>
            </div>
          </div>
        </div>
      )}


      {modalExtrato && extrato && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15,25,40,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", borderRadius: "12px", width: "860px", maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid rgba(26,58,92,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: "16px", fontWeight: "700", color: "#1C2533" }}>Extrato — {modalExtrato.nome}</div>
                <div style={{ fontSize: "12px", color: "#6B7A8D" }}>{modalExtrato.banco}{modalExtrato.agencia ? " · Ag: " + modalExtrato.agencia : ""}{modalExtrato.conta ? " · CC: " + modalExtrato.conta : ""}</div>
              </div>
              <button onClick={() => { setModalExtrato(null); setExtrato(null); }} style={{ background: "none", border: "none", fontSize: "22px", color: "#9AA3AE", cursor: "pointer" }}>x</button>
            </div>
            <div style={{ padding: "12px 24px", borderBottom: "1px solid rgba(26,58,92,0.08)", display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
              <input type="date" value={filtroExtrato.inicio} onChange={e => { const f = { ...filtroExtrato, inicio: e.target.value }; setFiltroExtrato(f); carregarExtrato(modalExtrato, f); }} style={{ padding: "6px 10px", background: "#F4F6F9", border: "0.5px solid rgba(26,58,92,0.15)", borderRadius: "7px", fontSize: "13px" }} />
              <input type="date" value={filtroExtrato.fim} onChange={e => { const f = { ...filtroExtrato, fim: e.target.value }; setFiltroExtrato(f); carregarExtrato(modalExtrato, f); }} style={{ padding: "6px 10px", background: "#F4F6F9", border: "0.5px solid rgba(26,58,92,0.15)", borderRadius: "7px", fontSize: "13px" }} />
              <div style={{ marginLeft: "auto", display: "flex", gap: "20px" }}>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "10px", color: "#9AA3AE", textTransform: "uppercase", fontWeight: "600" }}>Saldo inicial</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", fontFamily: "DM Mono,monospace", color: "#6B7A8D" }}>R$ {parseFloat(extrato.saldo_inicial).toLocaleString("pt-BR", {minimumFractionDigits:2})}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "10px", color: "#9AA3AE", textTransform: "uppercase", fontWeight: "600" }}>Saldo atual</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", fontFamily: "DM Mono,monospace", color: parseFloat(extrato.saldo_atual) >= 0 ? "#2D7D4F" : "#C0392B" }}>R$ {parseFloat(extrato.saldo_atual).toLocaleString("pt-BR", {minimumFractionDigits:2})}</div>
                </div>
              </div>
            </div>
            <div style={{ overflowY: "auto", flex: 1 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ position: "sticky", top: 0, background: "#F4F6F9" }}>
                  <tr>
                    {["Data", "Descricao", "Tipo", "Valor", "Saldo", ""].map(h => (
                      <th key={h} style={{ padding: "10px 16px", textAlign: h === "Valor" || h === "Saldo" ? "right" : "left", fontSize: "10.5px", color: "#9AA3AE", fontWeight: "600", textTransform: "uppercase", borderBottom: "1px solid rgba(26,58,92,0.1)" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {extrato.extrato.length === 0 && (
                    <tr><td colSpan={5} style={{ padding: "32px", textAlign: "center", color: "#9AA3AE" }}>Nenhuma movimentacao no periodo</td></tr>
                  )}
                  {extrato.extrato.map((l, idx) => (
                    <tr key={l.id} style={{ background: idx % 2 === 0 ? "#fff" : "#FAFBFC" }}>
                      <td style={{ padding: "10px 16px", fontSize: "12px", color: "#6B7A8D", fontFamily: "DM Mono,monospace", whiteSpace: "nowrap" }}>{l.data_pagamento ? l.data_pagamento.split("T")[0].split("-").reverse().join("/") : "—"}</td>
                      <td style={{ padding: "10px 16px", fontSize: "13px", color: "#1C2533" }}>{l.descricao}</td>
                      <td style={{ padding: "10px 16px" }}>
                        <span style={{ background: l.tipo === "receita" ? "#EAF5EE" : "#FDECEA", color: l.tipo === "receita" ? "#2D7D4F" : "#C0392B", padding: "2px 8px", borderRadius: "20px", fontSize: "11px", fontWeight: "600" }}>
                          {l.tipo === "receita" ? "Entrada" : "Saida"}
                        </span>
                      </td>
                      <td style={{ padding: "10px 16px", textAlign: "right", fontFamily: "DM Mono,monospace", fontSize: "13px", fontWeight: "700", color: l.tipo === "receita" ? "#2D7D4F" : "#C0392B" }}>
                        {l.tipo === "receita" ? "+" : "-"}R$ {parseFloat(l.valor).toLocaleString("pt-BR", {minimumFractionDigits:2})}
                      </td>
                      <td style={{ padding: "10px 16px", textAlign: "right", fontFamily: "DM Mono,monospace", fontSize: "13px", fontWeight: "700", color: parseFloat(l.saldo_apos) >= 0 ? "#1C2533" : "#C0392B" }}>
                        R$ {parseFloat(l.saldo_apos).toLocaleString("pt-BR", {minimumFractionDigits:2})}
                      </td>
                      <td style={{ padding: "10px 16px", textAlign: "center" }}>
                        <button onClick={async () => {
                          if (!window.confirm("Cancelar este lancamento?")) return;
                          await api.delete("/financeiro/lancamentos/" + l.id);
                          carregarExtrato(modalExtrato);
                        }} style={{ padding: "2px 8px", background: "#FDECEA", border: "none", color: "#C0392B", borderRadius: "5px", cursor: "pointer", fontSize: "12px", fontWeight: "700" }}>×</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {/* MODAL DIVIDIR PAGAMENTO */}
      {modalDividir && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '520px', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>Dividir pagamento</h3>
              <button onClick={() => setModalDividir(null)} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#6B7A8D' }}>
              <strong style={{ color: '#1C2533' }}>{modalDividir.descricao}</strong> · {fmt(modalDividir.valor)}
            </div>
            <div style={{ fontSize: '12px', color: '#9AA3AE', marginBottom: '12px' }}>
              Defina o valor e a conta bancária de cada forma de pagamento. O lançamento original será cancelado e substituído pelos novos.
            </div>
            {divisoes.map((d, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '8px', marginBottom: '8px', alignItems: 'flex-end' }}>
                <div>
                  {i === 0 && <label style={lbl}>Forma / Descrição</label>}
                  <input placeholder='Ex: PIX, Dinheiro...' value={d.forma}
                    onChange={e => setDivisoes(ds => ds.map((x,idx) => idx===i ? {...x, forma: e.target.value} : x))}
                    style={inpStyle} />
                </div>
                <div>
                  {i === 0 && <label style={lbl}>Valor</label>}
                  <input type='number' step='0.01' placeholder='0,00' value={d.valor}
                    onChange={e => setDivisoes(ds => ds.map((x,idx) => idx===i ? {...x, valor: e.target.value} : x))}
                    style={inpStyle} />
                </div>
                <div>
                  {i === 0 && <label style={lbl}>Conta</label>}
                  <select value={d.conta_id || ''} onChange={e => setDivisoes(ds => ds.map((x,idx) => idx===i ? {...x, conta_id: e.target.value} : x))} style={inpStyle}>
                    <option value=''>Selecione</option>
                    {contas.map(ct => <option key={ct.id} value={String(ct.id)}>{ct.nome}</option>)}
                  </select>
                </div>
                {divisoes.length > 2 && (
                  <button onClick={() => setDivisoes(ds => ds.filter((_,idx) => idx !== i))}
                    style={{ padding: '8px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '6px', cursor: 'pointer' }}>×</button>
                )}
              </div>
            ))}
            <button onClick={() => setDivisoes(ds => [...ds, { forma: '', valor: '', conta_id: '' }])}
              style={{ padding: '7px 12px', background: 'transparent', border: '1px dashed rgba(26,58,92,0.3)', color: '#1A3A5C', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontFamily: "'DM Sans',system-ui,sans-serif", width: '100%', marginBottom: '14px' }}>
              + Adicionar forma
            </button>
            {divisoes.filter(d => d.valor).length >= 2 && (
              <div style={{ background: '#EAF5EE', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#2D7D4F', fontWeight: '600' }}>Total dividido</span>
                <span style={{ fontFamily: "'DM Mono',monospace", fontWeight: '700', color: '#2D7D4F' }}>{fmt(divisoes.reduce((a,d) => a + parseFloat(d.valor||0), 0))}</span>
              </div>
            )}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalDividir(null)}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                Cancelar
              </button>
              <button onClick={salvarDivisao}
                style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                ÷ Confirmar divisão
              </button>
            </div>
          </div>
        </div>
      )}

      {modalParcial && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '400px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', marginBottom: '6px' }}>Baixa parcial</h3>
            <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '16px' }}>{modalParcial.descricao} · Total: {fmt(modalParcial.valor)}</div>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Valor recebido agora</label>
              <input type='number' step='0.01' value={valorParcial} onChange={e => setValorParcial(e.target.value)}
                placeholder={'Max: ' + parseFloat(modalParcial.valor).toFixed(2)} style={inpStyle} autoFocus />
              {valorParcial && parseFloat(valorParcial) < parseFloat(modalParcial.valor) && (
                <div style={{ fontSize: '12px', color: '#E67E22', marginTop: '4px' }}>
                  Saldo restante: {fmt(parseFloat(modalParcial.valor) - parseFloat(valorParcial))} ficara pendente
                </div>
              )}
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label style={lbl}>Conta</label>
              <select value={form.conta_id_pag || ''} onChange={e => setForm(f => ({ ...f, conta_id_pag: e.target.value }))} style={inpStyle}>
                <option value=''>Sem conta</option>
                {contas.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={lbl}>Data de recebimento</label>
              <input type='date' value={form.data_pagamento || hoje} onChange={e => setForm(f => ({ ...f, data_pagamento: e.target.value }))} style={inpStyle} />
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => { setModalParcial(null); setValorParcial(''); setForm({}); }}
                style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Cancelar</button>
              <button onClick={pagarParcial}
                style={{ flex: 1, padding: '10px', background: '#E67E22', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Confirmar baixa</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
